import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import {
    SystemPlatformDetailsItem,
    SystemPlatformDetailsSpecificationItem,
    SystemPlatformDetailsEncodeConfigurationItem,
    SystemPlatformDetailsDeliveryInfoItem
} from "../SystemPlatformDetailsItem";

interface ISystemPlatformDetailsContext {
    systemPlatformDetailsItem: SystemPlatformDetailsItem;
    isLoading: boolean;
    updateSpecification(specification: SystemPlatformDetailsSpecificationItem): void;
    updateEncodeConfiguration(encodeConfiguration: SystemPlatformDetailsEncodeConfigurationItem): void;
    resetSpecifications(): void;
    updateDeliveryInfo(deliveryInfo: SystemPlatformDetailsDeliveryInfoItem): void;
    updateBuzzIds(buzzIds: string[]): void;
    updateShreqIds(shreqIds: string[]): void;
}

export const SystemPlatformDetailsContext = createContext<ISystemPlatformDetailsContext>({
    systemPlatformDetailsItem: {
        system: {
            id: "",
            name: ""
        },
        integrator: {
            id: "",
            name: ""
        },
        airline: {
            id: "",
            name: ""
        },
        specifications: [],
        encodeConfiguration: {
            muxSpecification: undefined,
            subtitlesTargetFileName: undefined,
            audioProxyType: undefined,
            muxSubtitleType: undefined,
            copySubtitleType: undefined,
            closedCaptionCode: "",
            subtitlesCaptionCode: "",
            languageSpecification: undefined
        },
        deliveryInfo: {
            deliveryEndpoint: undefined,
            distributionList: undefined
        },
        buzzIds: [],
        shreqIds: []
    },
    isLoading: false,
    updateSpecification: contextFunctionInit,
    updateEncodeConfiguration: contextFunctionInit,
    resetSpecifications: contextFunctionInit,
    updateDeliveryInfo: contextFunctionInit,
    updateBuzzIds: contextFunctionInit,
    updateShreqIds: contextFunctionInit
});
